"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSchemaType = exports.KeyTypes = exports.TypeTags = void 0;
var tslib_1 = require("tslib");
/**
 * The enumeration of types supported by this marshaller package.
 */
exports.TypeTags = {
    Any: 'Any',
    Binary: 'Binary',
    Boolean: 'Boolean',
    Collection: 'Collection',
    Custom: 'Custom',
    Date: 'Date',
    Document: 'Document',
    Hash: 'Hash',
    List: 'List',
    Map: 'Map',
    Null: 'Null',
    Number: 'Number',
    Set: 'Set',
    String: 'String',
    Tuple: 'Tuple',
};
function isBaseType(arg) {
    return Boolean(arg) && typeof arg === 'object'
        && typeof arg.type === 'string'
        && arg.type in exports.TypeTags
        && ['string', 'undefined'].indexOf(typeof arg.attributeName) > -1;
}
/**
 * The types of keys a given attribute can represent.
 */
exports.KeyTypes = {
    HASH: 'HASH',
    RANGE: 'RANGE',
};
function isKeyableType(arg) {
    var e_1, _a;
    var _b = arg, keyType = _b.keyType, indexKeyConfigurations = _b.indexKeyConfigurations;
    if (!(keyType === undefined || keyType in exports.KeyTypes)) {
        return false;
    }
    var idxKeysType = typeof indexKeyConfigurations;
    if (indexKeyConfigurations && idxKeysType === 'object') {
        try {
            for (var _c = tslib_1.__values(Object.keys(indexKeyConfigurations)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var indexName = _d.value;
                if (!(indexKeyConfigurations[indexName] in exports.KeyTypes)) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    }
    return idxKeysType === 'undefined';
}
function isSchemaType(arg, alreadyVisited) {
    if (alreadyVisited === void 0) { alreadyVisited = new Set(); }
    if (isBaseType(arg)) {
        if (alreadyVisited.has(arg)) {
            return true;
        }
        alreadyVisited.add(arg);
        switch (arg.type) {
            case 'Binary':
            case 'Date':
            case 'String':
                return isKeyableType(arg);
            case 'Custom':
                return isKeyableType(arg)
                    && typeof arg.marshall === 'function'
                    && typeof arg.unmarshall === 'function'
                    && [
                        void 0,
                        'S',
                        'N',
                        'B',
                    ].indexOf(arg.attributeType) > -1;
            case 'Document':
                return isDocumentType(arg, alreadyVisited);
            case 'List':
            case 'Map':
                return isSchemaType(arg.memberType, alreadyVisited);
            case 'Number':
                return isKeyableType(arg) && ['boolean', 'undefined']
                    .indexOf(typeof arg.versionAttribute) > -1;
            case 'Tuple':
                return isTupleType(arg, alreadyVisited);
            default:
                return true;
        }
    }
    return false;
}
exports.isSchemaType = isSchemaType;
function isDocumentType(arg, alreadyVisited) {
    var e_2, _a;
    var _b = arg, valueConstructor = _b.valueConstructor, members = _b.members;
    if (!members || typeof members !== 'object') {
        return false;
    }
    try {
        for (var _c = tslib_1.__values(Object.keys(members)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            if (!isSchemaType(members[key], alreadyVisited)) {
                return false;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return ['function', 'undefined',].indexOf(typeof valueConstructor) > -1;
}
function isTupleType(arg, alreadyVisited) {
    var e_3, _a;
    var members = arg.members;
    if (!Array.isArray(members)) {
        return false;
    }
    try {
        for (var members_1 = tslib_1.__values(members), members_1_1 = members_1.next(); !members_1_1.done; members_1_1 = members_1.next()) {
            var member = members_1_1.value;
            if (!isSchemaType(member, alreadyVisited)) {
                return false;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (members_1_1 && !members_1_1.done && (_a = members_1.return)) _a.call(members_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return true;
}
